export default {"src":"/_next/static/media/comingSoonTimer.5f05337f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};